import React from 'react';

/** A settings switch. Worded state, not a coloured pill. */
export function ToggleRow({ label, help, value = false, valueLabel, onChange, style }) {
  return (
    <div onClick={onChange ? () => onChange(!value) : undefined} style={{
      display: 'flex', alignItems: 'flex-start', gap: 'var(--bujo-space-3)',
      minHeight: 'var(--bujo-tap-min)', padding: 'var(--bujo-space-3) 0',
      borderBottom: '1px solid var(--bujo-rule-hairline)',
      cursor: onChange ? 'pointer' : 'default', ...style
    }}>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span style={{
          display: 'block',
          font: 'var(--bujo-fw-regular) 13.5px/var(--bujo-lh-row) var(--bujo-font-mono)',
          color: 'var(--bujo-text-primary)'
        }}>{label}</span>
        {help ? (
          <span style={{
            display: 'block', marginTop: 4,
            font: 'var(--bujo-fw-regular) 11.5px/var(--bujo-lh-row) var(--bujo-font-sans)',
            color: 'var(--bujo-text-meta)'
          }}>{help}</span>
        ) : null}
      </span>
      <span style={{
        flex: 'none',
        font: 'var(--bujo-fw-bold) var(--bujo-fs-label)/var(--bujo-lh-tight) var(--bujo-font-mono)',
        letterSpacing: 'var(--bujo-ls-badge)',
        color: value ? 'var(--bujo-accent)' : 'var(--bujo-text-meta)'
      }}>{valueLabel || (value ? 'ON' : 'OFF')}</span>
    </div>
  );
}
